import {Component, OnInit} from '@angular/core';
import {UntypedFormBuilder, UntypedFormGroup} from '@angular/forms';
import {TipoPagamentoEcgTerceiro} from '../../../model/tipo-pagamento-ecg-terceiro';
import {TipoPagamentoEcgTerceiroService} from '../../contratacao/operacao/tipo-pagamento-ecg-terceiro.service';

@Component({
  selector: 'app-ecg-por-terceiros-pesquisa',
  templateUrl: './ecg-por-terceiros-pesquisa.component.html',
  styleUrls: ['./ecg-por-terceiros-pesquisa.component.scss'],
  standalone: false
})
export class EcgPorTerceirosPesquisaComponent implements OnInit {

  protected pesquisaForm: UntypedFormGroup = null;
  public listarTodosEcgPorTerceiros: TipoPagamentoEcgTerceiro[];
  public ecgTerceirosPesquisado: TipoPagamentoEcgTerceiro[];
  public pesquisado: boolean = false;

  constructor(private formBuilder: UntypedFormBuilder,
              private TipoPagamentoEcgTerceiroService: TipoPagamentoEcgTerceiroService) {
  }

  ngOnInit() {
    this.pesquisaForm = this.createReactiveForm();

    this.TipoPagamentoEcgTerceiroService.listarTodos().subscribe(res => {
      this.listarTodosEcgPorTerceiros = res;
    });
  }

  buscar() {
    this.TipoPagamentoEcgTerceiroService.buscarFiltradoTipoPagamentoEcgTerceiro(this.obterFiltrosBusca()).subscribe(res => {
      this.ecgTerceirosPesquisado = res;
      this.pesquisado = true;
    });
  }

  limpar() {
    this.pesquisaForm.reset({
      ideEcgTerceiro: null
    });
    this.pesquisado = false;
    this.ecgTerceirosPesquisado = [];
  }


  obterFiltrosBusca() {
    let dadosPreenchidos: any = {};
    const form = this.pesquisaForm.value;

    if (form.ideEcgTerceiro) {
      dadosPreenchidos.ideEcgTerceiro = form.ideEcgTerceiro;
    }

    return dadosPreenchidos;
  }

  createReactiveForm(): UntypedFormGroup {

    return this.formBuilder.group({
      ideEcgTerceiro: null
    });
  }

}
